import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const rel = (u) => String(u || "").replace(/^\/api/, "");

export const fetchBlobUrl = async (u) => URL.createObjectURL((await api.get(rel(u), { responseType: "blob" })).data);

export const openAuthFile = async (u) => {
  try { window.open(await fetchBlobUrl(u), "_blank", "noopener"); } catch (e) { toast.error(formatApiError(e)); }
};

export function AuthImg({ src, alt = "", className = "", testid }) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    let live = true, obj = "";
    fetchBlobUrl(src).then((u) => { obj = u; if (live) setUrl(u); }).catch(() => {});
    return () => { live = false; if (obj) URL.revokeObjectURL(obj); };
  }, [src]);
  return url ? <img src={url} alt={alt} className={className} data-testid={testid} /> : <div className={`${className} bg-white/5 animate-pulse`} />;
}
